"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._runAction = _runAction;
exports.reload = exports.registerAction = exports.model = exports.miniWebview = exports.hidden = exports.goUrlParam = exports.goUrl = exports.goFormUrl = exports.goBack = exports.getGlobleData = exports.getFormData = exports.flexiblePopup = exports.flexibleModal = exports.fetchInterface = exports.download = exports.deleteChildren = exports.default = exports.copyChildren = exports.copy = exports.alert = void 0;
exports.runActions = runActions;
exports.update = exports.toastModal = exports.toast = exports.tips = exports.share = void 0;
exports.useActions = useActions;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _bridge = _interopRequireDefault(require("@iyunbao/bridge"));

var _classnames3 = _interopRequireDefault(require("classnames"));

var _lodash = require("lodash");

var _tools = require("./utils/tools");

var _preValidate = require("./preValidate");

var _helper = require("./utils/helper");

var _template = _interopRequireDefault(require("./template"));

var _render = require("./render");

var _fetchAPI = _interopRequireWildcard(require("./utils/fetchAPI"));

var _cascade = require("./cascade");

var _components = require("./components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var root = {};

if (typeof window !== 'undefined') {
  root = window;
} // declare var window: WindowProps;


// eslint-disable-next-line import/no-mutable-exports
var ActionConfig = {};

/**
 * 跳转链接
 * @param  {string|object} url               链接地址、数据{ url: '' }
 * @config {string}        url               链接
 * @config {string}        mode              跳转方式，默认：history，可选：href
 * @config {boolean}       isMiniprogramUrl  是否小程序链接，
 * @param  {function}  cb   回调
 */
var goUrl = function goUrl(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var callback = options.callback;

  if (!url) {
    console.error('action url');
    return false;
  }

  var mode = 'history';
  var isMiniprogramUrl = false;

  if (callback && (0, _tools.isFunction)(callback)) {
    callback(url);
  }

  if ((0, _tools.isObject)(url)) {
    var _url = url;
    url = _url.url;
    var _url$mode = _url.mode;
    mode = _url$mode === void 0 ? 'history' : _url$mode;
    var _url$isMiniprogramUrl = _url.isMiniprogramUrl;
    isMiniprogramUrl = _url$isMiniprogramUrl === void 0 ? false : _url$isMiniprogramUrl;
  } // 小程序 webview
  // load SDK 防止页面未引入script


  if (isMiniprogramUrl && root.__wxjs_environment === 'miniprogram') {
    (0, _tools.loadMiniProgramSDK)(function () {
      root.wx.miniProgram.navigateTo({
        url: url
      });
    });
  } else if (mode && mode === 'history') {
    // ios JSBridge.go 打开新webview 下一个页面 localstorage带不过去
    (0, _tools.historyPush)(url);
  } else {
    window.location.href = url;
  }
};
/**
 * 跳转链接，带当前参数一起带下一个页面
 * @param  {string|object} url  链接地址、数据{ url: '' }
 * @config {string}        url  链接
 * @config {string}        mode       跳转方式，默认：history，可选：href
 * @param  {string} locUrl 取值链接，未传直接回调
 * @param  {function}  cb   回调
 */


exports.goUrl = goUrl;

var goUrlParam = function goUrlParam(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var locUrl = options.locUrl,
      callback = options.callback;

  if (!url) {
    console.error('action url param');
    return false;
  }

  var mode = 'history';
  var isMiniprogramUrl = false; // 回调

  if ((0, _tools.isFunction)(locUrl)) {
    locUrl(url);
  } else if (callback && (0, _tools.isFunction)(callback)) {
    callback(url);
  }

  if ((0, _tools.isObject)(url)) {
    var _url2 = url;
    url = _url2.url;
    var _url2$mode = _url2.mode;
    mode = _url2$mode === void 0 ? 'history' : _url2$mode;
    var _url2$isMiniprogramUr = _url2.isMiniprogramUrl;
    isMiniprogramUrl = _url2$isMiniprogramUr === void 0 ? false : _url2$isMiniprogramUr;
  }

  var tempUrl = typeof locUrl === 'string' ? locUrl : root.location.href;
  var urlParams = (0, _tools.urlAllParams)(tempUrl);
  var addParams = [];
  var reg;
  Object.keys(urlParams).map(function (key) {
    reg = new RegExp("".concat(key, "=")); // 去重复参数

    if (!reg.test(url)) {
      addParams.push("".concat(key, "=").concat(encodeURIComponent(urlParams[key])));
    }

    return key;
  });
  url += /\?/.test(url) ? '&' : '?';
  url += addParams.join('&'); // 小程序 webview
  // load SDK 防止页面未引入script

  if (isMiniprogramUrl && root.__wxjs_environment === 'miniprogram') {
    (0, _tools.loadMiniProgramSDK)(function () {
      root.wx.miniProgram.navigateTo({
        url: url
      });
    });
  } else if (mode && mode === 'history') {
    (0, _tools.historyPush)(url);
  } else {
    window.location.href = url;
  }
};
/**
 * 小程序内嵌H5(webview)，返回小程序
 * @param  {object}   data    数据
 * @config {string}   url     跳转路径
 * @config {string}   type    返回小程序
 * @param  {function} cb      回调
 */


exports.goUrlParam = goUrlParam;

var miniWebview = function miniWebview(data) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var callback = options.callback;

  if (!(0, _tools.isObject)(data)) {
    return false;
  }

  var url = data.url,
      type = data.type;

  if (callback && (0, _tools.isFunction)(callback)) {
    callback(data);
  } // 小程序 webview
  // load SDK 防止页面未引入script


  if (root.__wxjs_environment === 'miniprogram') {
    (0, _tools.loadMiniProgramSDK)(function () {
      switch (type) {
        case 'reLaunch':
          root.wx.miniProgram.reLaunch({
            url: url
          });
          break;

        case 'switchTab':
          root.wx.miniProgram.switchTab({
            url: url
          });
          break;

        default:
          root.wx.miniProgram.navigateTo({
            url: url
          });
          break;
      }
    });
  }
};
/**
 * 跳转form
 * @param  {object}  data    数据
 * @config {string}  method  发送类型
 * @config {string}  url     发送链接
 * @config {object}  params  参数
 * @config {string}  acceptCharset  字符编码
 * @param  {function} cb      回调
 */


exports.miniWebview = miniWebview;

var goFormUrl = function goFormUrl(data, options) {
  var callback = options.callback;
  var _data$method = data.method,
      method = _data$method === void 0 ? 'get' : _data$method,
      url = data.url,
      params = data.params,
      acceptCharset = data.acceptCharset;

  if (callback && (0, _tools.isFunction)(callback)) {
    callback(data);
  }

  if (method && method.toUpperCase() === 'GET') {
    root.location.href = url;
  } else {
    var form = document.createElement('form');
    form.action = url;
    form.method = method;
    form.id = "go_url_".concat(Math.random()); // 跳转保司gbk编码

    if (acceptCharset) {
      form.acceptCharset = acceptCharset;
    }

    document.body.appendChild(form);

    if (params) {
      Object.keys(params).forEach(function (key) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = params[key];
        form.appendChild(input);
      });
    }

    form.submit();
  }
};
/**
 * 刷新页面
 * @param  {function} cb   回调
 */


exports.goFormUrl = goFormUrl;

var reload = function reload(data) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var callback = options.callback;

  if (callback && (0, _tools.isFunction)(callback)) {
    callback();
  }

  if (root.history) {
    root.history.go(0);
  } else {
    root.location.reload();
  }
};
/**
 * 返回上一个页面
 * @param  {function} cb   回调
 */


exports.reload = reload;

var goBack = function goBack(data) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var callback = options.callback;

  if (callback && (0, _tools.isFunction)(callback)) {
    callback();
  } // 在webview跳转


  if (root.history && root.history.length > 1) {
    root.history.go(-1);
  } else {
    _bridge.default.ready(function () {
      _bridge.default.goBack();
    });
  }

  ;
};
/**
 * 下载
 * @param  {object}   data 数据
 * @config {string}   url  链接
 * @config {string}   name 窗口打开状态，默认_blank
 * @param  {function} cb   回调
 */


exports.goBack = goBack;

var download = function download(data) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var callback = options.callback;

  if (!data) {
    console.error('action download params');
    return Promise.reject(Error('action download params'));
  }

  if (callback && (0, _tools.isFunction)(callback)) {
    callback(data);
  }

  root.open(data.url, data.name || '_blank');
  return Promise.resolve();
};
/**
 * 弱提示
 * @param  {string||object} message 数据
 * @config {string}   message       提示文案
 * @config {number}   duration      自动隐藏时间，默认3000
 * @param  {boolean}  mask          是否展示遮罩层，默认true
 * @param  {function} afterClose    关闭回调
 */


exports.download = download;

var toast = function toast(data) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!data) {
    console.error('action toast');
    return Promise.reject(Error('action toast'));
  }

  var afterClose = options.afterClose;
  var duration = options.duration;
  var cb = (0, _tools.isFunction)(duration) ? duration : afterClose;
  var message = data;
  var mask = true;

  if ((0, _tools.isObject)(data)) {
    message = data.message;

    // 自动隐藏时间
    if (data.duration) {
      duration = data.duration;
    } // 是否显示遮罩层，不影响用户操作。默认true


    if (typeof data.mask !== 'undefined') {
      mask = data.mask;
    } // 兼容个险历史动作规则，新接入禁止使用


    if (data.value && !message) {
      message = data.value;
    }
  }

  if (document.getElementById('actionToast')) {
    return Promise.reject(Error('重复'));
    ;
  }

  var div = document.createElement('div');
  div.id = 'actionToast';
  document.body.appendChild(div);

  var onClose = function onClose() {
    if (cb && (0, _tools.isFunction)(cb)) {
      cb(data);
    }

    _reactDom.default.unmountComponentAtNode(div);

    document.body.removeChild(div);
  };

  return new Promise(function (resolve) {
    _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_components.Toast, {
      visible: true,
      mask: mask,
      stayTime: typeof duration === 'number' ? duration : 3000,
      afterClose: function afterClose() {
        resolve({});
        onClose();
      }
    }, message), div);
  });
};
/**
 * 数据格式和toast一致 长文案后端会通过modal形式提示
 * @param data
 * @param cb
 * @returns
 */


exports.toast = toast;

var toastModal = function toastModal(data, cb) {
  if (!data) {
    console.error('action toast modal');
    return false;
  }

  if (document.getElementById('actionToastModal')) {
    return false;
  }

  var message = data;
  var title = '';
  var label = '';

  if ((0, _tools.isObject)(data)) {
    message = data.message;
    title = data.title;
    label = data.label;

    // 兼容个险历史动作规则，新接入禁止使用
    if (data.value && !message) {
      message = data.value;
    }
  }

  var div = document.createElement('div');
  div.id = 'actionToastModal';
  document.body.appendChild(div);

  var _onClose = function onClose() {
    if (cb && (0, _tools.isFunction)(cb)) {
      cb(data);
    }

    _reactDom.default.unmountComponentAtNode(div);

    document.body.removeChild(div);
  };

  var prefixCls = 'cre-modal';
  var modelCls = _tools.isMobile || _tools.isInApp ? "".concat(prefixCls, "-mobile") : "".concat(prefixCls, "-web");
  var width = _tools.isMobile || _tools.isInApp ? '80%' : '880px';
  var cls = (0, _classnames3.default)(prefixCls, modelCls);

  _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_components.Modal, {
    visible: true,
    className: cls,
    width: width,
    onMaskClick: _onClose
  }, title && /*#__PURE__*/_react.default.createElement(_components.Modal.Header, {
    title: title,
    onClose: function onClose() {
      return _onClose();
    }
  }), /*#__PURE__*/_react.default.createElement(_components.Modal.Body, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-body modal-toast-body-center")
  }, message)), /*#__PURE__*/_react.default.createElement(_components.Modal.Footer, null, /*#__PURE__*/_react.default.createElement("button", {
    className: "".concat(prefixCls, "-button modal-toast-button-color"),
    onClick: _onClose
  }, label || '我知道了'))), div);
};

exports.toastModal = toastModal;

/**
 * 复制文本
 * @param  {object}   data    复制数据
 * @config {string}   text    文本
 * @param  {function} cb      回调
 */
var copy = function copy(data) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var callback = options.callback;

  var _ref = data || {},
      text = _ref.text;

  if (typeof text !== 'string') {
    console.error('请传入字符串');
    return false;
  }

  if (callback && (0, _tools.isFunction)(callback)) {
    callback(data);
  }

  try {
    var div = document.createElement('div');
    div.innerHTML = text;
    document.body.appendChild(div);
    root.getSelection().removeAllRanges();
    var range = document.createRange();
    range.selectNode(div);
    root.getSelection().addRange(range);
    var success = document.execCommand('copy');

    if (success) {
      toast('复制成功');
    } else {
      toast('复制失败');
    }

    root.getSelection().removeAllRanges();
    document.body.removeChild(div);
    return Promise.resolve(text);
  } catch (error) {
    console.error(error);
  }

  return Promise.reject(Error('copy错误'));
};

exports.copy = copy;

/**
 * 弹层
 * @param  {object}   data    数据
 * @config {string}   label   标题
 * @config {object[]} options 内容
 * @config {object[]} footer  底部
 * @param  {function} cb   回调
 */
var model = function model(data) {
  var mOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (document.getElementById('actionModel')) {
    return false;
  }

  var callback = mOptions.callback;
  var div = document.createElement('div');
  div.id = 'actionModel';
  document.body.appendChild(div);
  var prefixCls = 'cre-modal'; // type=line

  var label = data.label,
      options = data.options,
      footer = data.footer,
      buttons = data.buttons,
      closable = data.closable,
      className = data.className,
      widget = data.widget,
      log = data.log,
      onLog = data.onLog;
  var type = data.type; // type=line
  // 兼容旧动作

  if (widget && widget === 'text-model-line') {
    type = 'line';
  } // 打开弹框埋点


  if ((0, _tools.isFunction)(onLog) && log) {
    onLog && onLog(log);
  }

  var modelCls = _tools.isMobile || _tools.isInApp ? "".concat(prefixCls, "-mobile") : "".concat(prefixCls, "-web");
  var width = _tools.isMobile || _tools.isInApp ? '80%' : '880px';
  var cls = (0, _classnames3.default)(prefixCls, modelCls, _defineProperty({}, "".concat(prefixCls, "-").concat(type), !!type), className); // 关闭弹层

  var _onClose2 = function onClose() {
    if (callback && (0, _tools.isFunction)(callback)) {
      callback(data);
    }

    _reactDom.default.unmountComponentAtNode(div);

    document.body.removeChild(div);
  };

  var onButton = function onButton(action, resolve, reject) {
    if (action && action.action) {
      var _action = action;
      action = _action.action;
    }

    if (!(action && action.type)) {
      return false;
    }

    var _ref2 = action || {},
        acLog = _ref2.log; // 点击弹框按钮的埋点


    if (acLog && (0, _tools.isFunction)(onLog)) {
      onLog && onLog(acLog);
    }

    if (action.type === 'cancel') {
      _onClose2();

      reject(Error('取消'));
      return false;
    }

    if (ActionConfig[action.type]) {
      var _ActionConfig$action$, _ActionConfig;

      _onClose2();

      resolve({});
      (_ActionConfig$action$ = (_ActionConfig = ActionConfig)[action.type]) === null || _ActionConfig$action$ === void 0 ? void 0 : _ActionConfig$action$.call(_ActionConfig, action.data);
    }
  };

  var renderOptions = function renderOptions(item) {
    var itemtype = item.type,
        href = item.href,
        alt = item.alt,
        itemlabel = item.label,
        value = item.value,
        copyText = item.copyText;

    if (!itemtype) {
      return typeof item.label !== 'undefined' ? (0, _template.default)(itemlabel) : value;
    }

    switch (itemtype) {
      case 'image':
        return /*#__PURE__*/_react.default.createElement("img", {
          src: href,
          alt: alt || ''
        });

      case 'copy':
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", null, (0, _template.default)(itemlabel)), /*#__PURE__*/_react.default.createElement("span", {
          className: "model-copy-btn",
          onClick: function onClick() {
            return copy({
              text: copyText
            });
          }
        }, "\u590D\u5236"));

      default:
        break;
    }
  }; // 兼容老版本


  var footers = footer || buttons || [];
  return new Promise(function (resolve, reject) {
    _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_components.Modal, {
      visible: true,
      className: cls,
      width: width,
      onMaskClick: function onMaskClick() {
        reject(Error('取消'));

        _onClose2();
      }
    }, /*#__PURE__*/_react.default.createElement(_components.Modal.Header, {
      title: label,
      closable: closable,
      onClose: function onClose() {
        reject(Error('取消'));

        _onClose2();
      }
    }), /*#__PURE__*/_react.default.createElement(_components.Modal.Body, null, Array.isArray(options) && options.length ? options.map(function (item, index) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames3.default)("".concat(prefixCls, "-item"), _defineProperty({}, "".concat(prefixCls, "-item-").concat(item.type), !!item.type)),
        key: "item_".concat(index),
        style: item.style
      }, renderOptions(item));
    }) : null), /*#__PURE__*/_react.default.createElement(_components.Modal.Footer, null, Array.isArray(footers) && footers.length ? footers.map(function (item, index) {
      return /*#__PURE__*/_react.default.createElement("button", {
        className: "".concat(prefixCls, "-button"),
        key: "item_".concat(index),
        onClick: function onClick() {
          onButton(item, resolve, reject);
        },
        style: item.style
      }, item.label);
    }) : null)), div);
  });
};
/**
 * 警告框
 * @param  {object}   data    数据
 * @config {string}   label   标题
 * @config {array<{ label: string }>} options 内容
 * @config {array<{ label: string }>} footer  底部
 * @param  {function} cb   回调
 */


exports.model = model;

var alert = function alert(data) {
  var aOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (document.getElementById('actionAlert')) {
    return false;
  }

  var callback = aOptions.callback;
  var div = document.createElement('div');
  div.id = 'actionAlert';
  document.body.appendChild(div);
  var prefixCls = 'cre-alert';
  var label = data.label,
      options = data.options,
      className = data.className;
  var modelCls = _tools.isMobile ? "".concat(prefixCls, "-mobile") : "".concat(prefixCls, "-web");
  var width = _tools.isMobile ? '80%' : '880px';
  var footer = data.footer; // 关闭弹层

  var onClose = function onClose() {
    if (callback && (0, _tools.isFunction)(callback)) {
      callback(data);
    }

    _reactDom.default.unmountComponentAtNode(div);

    document.body.removeChild(div);
  };

  if (typeof footer === 'undefined') {
    footer = [{
      label: '知道了',
      action: {
        type: 'cancel'
      }
    }];
  }

  var onButton = function onButton(action, resolve, reject) {
    if (!(action && action.type)) {
      return;
    }

    if (action.type === 'cancel') {
      reject(Error('取消'));
      onClose();
      return;
    }

    if (ActionConfig[action.type]) {
      var _ActionConfig$action$2, _ActionConfig2;

      onClose();
      resolve({});
      (_ActionConfig$action$2 = (_ActionConfig2 = ActionConfig)[action.type]) === null || _ActionConfig$action$2 === void 0 ? void 0 : _ActionConfig$action$2.call(_ActionConfig2, action.data);
    }
  };

  return new Promise(function (resolve, reject) {
    _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_components.Modal, {
      visible: true,
      className: (0, _classnames3.default)(prefixCls, modelCls, className),
      width: width,
      onMaskClick: function onMaskClick() {
        reject(Error('取消'));
        onClose();
      }
    }, /*#__PURE__*/_react.default.createElement(_components.Modal.Header, {
      title: label
    }), /*#__PURE__*/_react.default.createElement(_components.Modal.Body, null, Array.isArray(options) && options.length ? options.map(function (item, index) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "".concat(prefixCls, "-item"),
        key: "item_".concat(index)
      }, item.label);
    }) : null), /*#__PURE__*/_react.default.createElement(_components.Modal.Footer, null, Array.isArray(footer) && footer.length ? footer.map(function (item, index) {
      return /*#__PURE__*/_react.default.createElement("button", {
        className: "".concat(prefixCls, "-button"),
        key: "item_".concat(index),
        onClick: function onClick() {
          onButton(item.action, resolve, reject);
        }
      }, item.label);
    }) : null)), div);
  });
};
/**
 * 提示层
 * @param {string}    content  内容模块
 * @param {string}    label    标题
 * @param  {function} cb       回调
 */


exports.alert = alert;

var tips = function tips(data, options) {
  var _ref3 = data || {},
      _ref3$content = _ref3.content,
      content = _ref3$content === void 0 ? '' : _ref3$content,
      _ref3$label = _ref3.label,
      label = _ref3$label === void 0 ? '' : _ref3$label;

  var callback = options.callback;

  if (document.getElementById('actionTips')) {
    return Promise.reject();
  }

  var div = document.createElement('div');
  div.id = 'actionTips';
  document.body.appendChild(div);
  var prefixCls = 'cre-alert';
  var modelCls = _tools.isMobile || _tools.isInApp ? "".concat(prefixCls, "-mobile") : "".concat(prefixCls, "-web");
  var width = _tools.isMobile || _tools.isInApp ? '80%' : '880px'; // 关闭弹层

  var _onClose3 = function onClose() {
    if (callback && (0, _tools.isFunction)(callback)) {
      callback(content);
    }

    _reactDom.default.unmountComponentAtNode(div);

    document.body.removeChild(div);
  };

  return new Promise(function (resolve) {
    _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_components.Modal, {
      visible: true,
      className: "".concat(prefixCls, " ").concat(modelCls),
      width: width,
      onMaskClick: function onMaskClick() {
        resolve({});

        _onClose3();
      }
    }, /*#__PURE__*/_react.default.createElement(_components.Modal.Header, {
      title: label,
      closable: true,
      onClose: function onClose() {
        resolve({});

        _onClose3();
      }
    }), /*#__PURE__*/_react.default.createElement(_components.Modal.Body, null, content)), div);
  });
};
/**
 * 接口获取数据
 * @param  {object}   fetch        接口参数
 * @config {string}   url          链接
 * @config {string}   method       请求类型
 * @config {string}   data         请求参数
 * @config {boolean}  isLoading    请求状态
 * @config {boolean}  toastMessage 提示信息
 * @config {boolean}  isUrlParam   是否携带链接参数
 * @param  {object}   params       附加参数
 * @param  {function} cb           回调
 */


exports.tips = tips;

var fetchInterface = function fetchInterface(fetch, options) {
  var _ref4 = options || {},
      _ref4$params = _ref4.params,
      params = _ref4$params === void 0 ? {} : _ref4$params,
      formData = _ref4.formData,
      _ref4$actions = _ref4.actions,
      actions = _ref4$actions === void 0 ? ActionConfig : _ref4$actions,
      callback = _ref4.callback,
      result = _ref4.result;

  var _ref5 = fetch || {},
      _ref5$url = _ref5.url,
      url = _ref5$url === void 0 ? '' : _ref5$url,
      method = _ref5.method,
      needFormData = _ref5.needFormData,
      _ref5$data = _ref5.data,
      data = _ref5$data === void 0 ? {} : _ref5$data,
      _ref5$isLoading = _ref5.isLoading,
      isLoading = _ref5$isLoading === void 0 ? false : _ref5$isLoading,
      _ref5$toastMessage = _ref5.toastMessage,
      toastMessage = _ref5$toastMessage === void 0 ? true : _ref5$toastMessage,
      _ref5$isUrlParam = _ref5.isUrlParam,
      isUrlParam = _ref5$isUrlParam === void 0 ? false : _ref5$isUrlParam;

  if (isLoading) {
    _components.Loading.show();
  }

  var urlParams = isUrlParam ? (0, _tools.urlAllParams)(root.location.href) : {};
  return _fetchAPI.default.fetch({
    path: url,
    method: method,
    data: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, result), urlParams), data), params), needFormData ? formData : {})
  }).finally(function () {
    if (isLoading) {
      _components.Loading.hide();
    }
  }).then(function (response) {
    if (callback && (0, _tools.isFunction)(callback)) {
      callback(response);
    }

    if (!response) {
      toast('返回数据异常');
      return Promise.reject(Error('返回数据异常'));
    }

    if (+response.code === 0 || response.result === 'success') {
      var newResult = (0, _fetchAPI.getFetchResult)(response);

      if (newResult && newResult.type && actions[newResult.type]) {
        actions[newResult.type](newResult.data);
      }

      return Promise.resolve(newResult);
    }

    if (toastMessage && (response.message || response.reason)) {
      toast(response.message || response.reason);
      return Promise.reject(response.message || response.reason);
    }
  });
};

exports.fetchInterface = fetchInterface;

/**
 * 调起分享，App内调起分享，浏览器跳转链接
 * @param {object}   data     分享数据
 * @config {string}  title    分享标题
 * @config {string}  desc     分享摘要
 * @config {string}  imgUrl   分享图片
 * @config {string}  link     分享链接
 * @param  {function} cb        回调
 */
var share = function share(data, options) {
  var callback = options.callback;

  if (callback && (0, _tools.isFunction)(callback)) {
    callback(data);
  }

  if (_tools.isInApp) {
    data = _objectSpread({
      link: window.location.href
    }, data);

    _bridge.default.ready(function () {
      _bridge.default.share(data);
    });
  } else if (data && data.link) {
    window.location.href = data.link;
  } else {
    toast('分享失败');
  }
};

exports.share = share;

var hidden = function hidden(data, _ref6) {
  var nameMap = _ref6.nameMap;
  var names = data.names;
  var dataProxy = (0, _helper.getDataProxyFromNameMap)(names, nameMap);

  if ((0, _tools.isObject)(dataProxy)) {
    dataProxy.hidden = true;
  }

  return Promise.resolve({});
};

exports.hidden = hidden;

var update = function update(data, _ref7) {
  var nameMap = _ref7.nameMap;
  var names = data.names,
      value = data.value,
      wprops = data.wprops;
  var dataProxy = (0, _helper.getDataProxyFromNameMap)(names, nameMap);

  if ((0, _tools.isObject)(dataProxy)) {
    (0, _cascade.assignObj)(dataProxy, {
      value: value,
      wprops: wprops
    });
  }

  return Promise.resolve({});
};

exports.update = update;

var copyChildren = function copyChildren(data, _ref8) {
  var nameMap = _ref8.nameMap,
      AUpdate = _ref8.update;
  var names = data.names,
      cloneChildren = data.childrens;
  var dataProxy = (0, _helper.getDataProxyFromNameMap)(names, nameMap);

  if ((0, _tools.isObject)(dataProxy) && Array.isArray(cloneChildren) && cloneChildren.length > 0) {
    var _dataProxy$childrens = dataProxy.childrens,
        childrens = _dataProxy$childrens === void 0 ? [] : _dataProxy$childrens;
    var length = cloneChildren.length;
    var nextChildren = [].concat(childrens, (0, _tools.deepCopy)(cloneChildren)).map(function (item, index) {
      if ((0, _tools.isObject)(item)) {
        (0, _helper.addIndexToPaths)(item, Math.floor(index / length));
        item.uuid = (0, _tools.uuid)();
      }

      return item;
    });
    dataProxy.childrens = nextChildren;
    AUpdate && AUpdate();
  }

  return Promise.resolve({});
}; // 删除当前元素最近的一个父元素


exports.copyChildren = copyChildren;

var deleteChildren = function deleteChildren(data, options) {
  var _ref9 = options || {},
      parent = _ref9.parent,
      parentIndex = _ref9.parentIndex,
      AUpdate = _ref9.update;

  var _ref10 = data || {},
      _ref10$length = _ref10.length,
      length = _ref10$length === void 0 ? 1 : _ref10$length,
      deleteIndex = _ref10.index,
      _ref10$selfRender = _ref10.selfRender,
      selfRender = _ref10$selfRender === void 0 ? false : _ref10$selfRender;

  var _parent;

  var getDeleteIndex = +("".concat(deleteIndex) || parentIndex);

  if (selfRender) {
    _parent = parent._parent;
  } else {
    _parent = parent;
  }

  var _parent2 = _parent,
      childrens = _parent2.childrens;
  var nextChildren = childrens.filter(function (child, index) {
    return getDeleteIndex !== Math.floor(index / length);
  }).map(function (item, index) {
    if ((0, _tools.isObject)(item)) {
      (0, _helper.addIndexToPaths)(item, Math.floor(index / length));
      item.uuid = (0, _tools.uuid)();
    }

    return item;
  });
  _parent.childrens = nextChildren;
  AUpdate && AUpdate();
  return Promise.resolve({});
};

exports.deleteChildren = deleteChildren;

var getFormData = function getFormData(data, options) {
  var formData = options.formData;
  var names = data.names;
  var tagForm = (0, _lodash.get)(formData, names, formData);
  return Promise.resolve(tagForm);
};

exports.getFormData = getFormData;

var getGlobleData = function getGlobleData(data, options) {
  var _ref11 = options || {},
      globleData = _ref11.globleData;

  var globleId = data.globleId;
  var tagForm = (0, _lodash.get)(globleData, globleId);
  return Promise.resolve(tagForm);
};

exports.getGlobleData = getGlobleData;

var flexibleModal = function flexibleModal(data, options) {
  var _ref12 = options || {},
      callback = _ref12.callback,
      result = _ref12.result,
      contextOptions = _ref12.options;

  var assignData = _objectSpread(_objectSpread({}, result), data);

  var header = assignData.header,
      footer = assignData.footer,
      content = assignData.content;
  var currentFormData = {};

  if (document.getElementById('actionFlexibleModal')) {
    return Promise.reject();
  }

  var div = document.createElement('div');
  div.id = 'actionFlexibleModal';
  document.body.appendChild(div);
  var prefixCls = 'cre-flexible-modal';
  var modelCls = _tools.isMobile ? "".concat(prefixCls, "-mobile") : "".concat(prefixCls, "-web");
  var width = _tools.isMobile ? '80%' : '880px'; // 关闭弹层

  var _onClose4 = function onClose() {
    if (callback && (0, _tools.isFunction)(callback)) {
      callback(content);
    }

    _reactDom.default.unmountComponentAtNode(div);

    document.body.removeChild(div);
  };

  return new Promise(function (resolve) {
    _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_components.Modal, {
      visible: true,
      className: "".concat(prefixCls, " ").concat(modelCls),
      width: width,
      onMaskClick: function onMaskClick() {
        resolve({});

        _onClose4();
      }
    }, /*#__PURE__*/_react.default.createElement(_components.Modal.Header, {
      title: /*#__PURE__*/_react.default.createElement(_render.AnalysisEngine, {
        formData: currentFormData,
        options: contextOptions,
        dataSource: header
      }),
      closable: true,
      onClose: function onClose() {
        resolve({});

        _onClose4();
      }
    }), /*#__PURE__*/_react.default.createElement(_components.Modal.Body, null, /*#__PURE__*/_react.default.createElement(_render.AnalysisEngine, {
      options: contextOptions,
      dataSource: content,
      formData: currentFormData
    })), footer && /*#__PURE__*/_react.default.createElement(_components.Modal.Footer, null, /*#__PURE__*/_react.default.createElement(_render.AnalysisEngine, {
      formData: currentFormData,
      options: contextOptions,
      dataSource: footer
    }))), div);
  });
};

exports.flexibleModal = flexibleModal;

var flexiblePopup = function flexiblePopup(data, options) {
  var _ref13 = options || {},
      callback = _ref13.callback,
      result = _ref13.result,
      contextOptions = _ref13.options;

  var assignData = _objectSpread(_objectSpread({}, result), data);

  var content = assignData.content,
      footer = assignData.footer,
      header = assignData.header,
      direction = assignData.direction;
  var currentFormData = {};
  var nameMap = {};
  var cascaderList = [];

  if (document.getElementById('actionFlexiblePopup')) {
    return Promise.reject();
  }

  var div = document.createElement('div');
  div.id = 'actionFlexiblePopup';
  document.body.appendChild(div);
  var prefixCls = 'cre-flexible-flexible';
  var modelCls = _tools.isMobile ? "".concat(prefixCls, "-mobile") : "".concat(prefixCls, "-web");
  var width = _tools.isMobile ? '80%' : '880px'; // 关闭弹层

  var onClose = function onClose() {
    if (callback && (0, _tools.isFunction)(callback)) {
      callback(content);
    }

    _reactDom.default.unmountComponentAtNode(div);

    document.body.removeChild(div);
  };

  return new Promise(function (resolve, reject) {
    var currentOptions = _objectSpread(_objectSpread({}, contextOptions), {}, {
      actions: _objectSpread(_objectSpread({}, contextOptions === null || contextOptions === void 0 ? void 0 : contextOptions.actions), {}, {
        onOk: function onOk() {
          resolve(currentFormData);
          onClose();
        },
        onCancel: function onCancel() {
          reject();
          onClose();
        }
      })
    });

    _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_components.LockScroll, {
      visible: true
    }, /*#__PURE__*/_react.default.createElement(_components.Popup, {
      visible: true,
      className: "".concat(prefixCls, " ").concat(modelCls),
      width: width,
      direction: direction,
      onMaskClick: function onMaskClick() {
        resolve({});
        onClose();
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(prefixCls, "-body")
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(prefixCls, "--header")
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(prefixCls, "--header__title")
    }, /*#__PURE__*/_react.default.createElement(_render.AnalysisEngine, {
      formData: currentFormData,
      options: currentOptions,
      dataSource: header,
      nameMap: nameMap,
      cascaderList: cascaderList
    })), /*#__PURE__*/_react.default.createElement("span", {
      className: "".concat(prefixCls, "__header__close"),
      onClick: function onClick() {
        reject();
        onClose();
      }
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(prefixCls, "--body")
    }, /*#__PURE__*/_react.default.createElement(_render.AnalysisEngine, {
      formData: currentFormData,
      nameMap: nameMap,
      cascaderList: cascaderList,
      options: currentOptions,
      dataSource: content
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(prefixCls, "--footer")
    }, /*#__PURE__*/_react.default.createElement(_render.AnalysisEngine, {
      formData: currentFormData,
      options: currentOptions,
      nameMap: nameMap,
      cascaderList: cascaderList,
      dataSource: footer
    }))))), div);
  });
};

exports.flexiblePopup = flexiblePopup;
ActionConfig = {
  hidden: hidden,
  update: update,
  flexibleModal: flexibleModal,
  flexiblePopup: flexiblePopup,
  copyChildren: copyChildren,
  deleteChildren: deleteChildren,
  getFormData: getFormData,
  getGlobleData: getGlobleData,
  // 跳转链接
  url: goUrl,
  // 跳转URL,带当前链接参数
  urlParam: goUrlParam,
  // 兼容旧版本。跳转URL,带当前链接参数
  'url-param': goUrlParam,
  // 小程序内嵌H5(webview)，返回小程序
  webview: miniWebview,
  // 用form方式跳转
  form: goFormUrl,
  // 接口请求数据
  fetch: fetchInterface,
  // 兼容旧接口请求
  ajax: fetchInterface,
  // 刷新当前页面
  reload: reload,
  // 返回上一页
  back: goBack,
  // 模版下载
  download: download,
  // 弱提示
  toast: toast,
  // 强提示，数据结构同toast
  'toast-modal': toastModal,
  // 弹层
  model: model,
  // 警告框
  alert: alert,
  // 调起分享
  share: share,
  // 复制文本
  copy: copy,
  tips: tips,
  'pre-validate': _preValidate.preValidate
};
/**
 * 注册全局动作
 * @param actionList 动作列表
 * return object
 */

var registerAction = function registerAction(actionList) {
  if (!(actionList && Object.keys(actionList).length)) {
    return ActionConfig;
  }

  ActionConfig = _extends(ActionConfig, actionList);
  return ActionConfig;
};

exports.registerAction = registerAction;

function _runAction(action, options) {
  var _ref14 = options || {},
      optionsActions = _ref14.actions;

  var actions = _objectSpread(_objectSpread({}, ActionConfig), optionsActions);

  if ((0, _tools.isObject)(action)) {
    var type = action.type,
        _data = action.data;

    if (type in actions) {
      var _actions$type3;

      if (['fetch', 'ajax'].indexOf(type) >= 0) {
        var _actions$type;

        return (_actions$type = actions[type]) === null || _actions$type === void 0 ? void 0 : _actions$type.call(actions, _data, options);
      }

      if (type === 'pre-validate') {
        var _actions$type2;

        return (_actions$type2 = actions[type]) === null || _actions$type2 === void 0 ? void 0 : _actions$type2.call(actions, _data, options);
      }

      return (_actions$type3 = actions[type]) === null || _actions$type3 === void 0 ? void 0 : _actions$type3.call(actions, _data, options);
    }
  }
}

function runActions(action, options) {
  if (Array.isArray(action)) {
    action.reduce( /*#__PURE__*/function () {
      var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(result, currentAction) {
        var currentResult;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!result) {
                  _context.next = 4;
                  break;
                }

                _context.next = 3;
                return result;

              case 3:
                result = _context.sent;

              case 4:
                _context.next = 6;
                return _runAction(currentAction, _objectSpread({
                  result: result
                }, options));

              case 6:
                currentResult = _context.sent;
                return _context.abrupt("return", currentResult);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref15.apply(this, arguments);
      };
    }(), undefined);
  }

  return _runAction(action, options);
}

function useActions() {
  var _useContext = (0, _react.useContext)(_render.AnalysisEngineContext),
      actions = _useContext.actions,
      formData = _useContext.formData,
      globleData = _useContext.globleData,
      nameMap = _useContext.nameMap,
      AUpdate = _useContext.update;

  return function (action, options) {
    runActions(action, _objectSpread({
      actions: actions,
      globleData: globleData,
      formData: formData,
      update: AUpdate,
      nameMap: nameMap
    }, options));
  };
} // 注入全局变量


root.CRE_ACTION = ActionConfig;
var _default = ActionConfig;
exports.default = _default;